<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->
@if (sections) {
  <div class="hours-column">
    <div
      class="blank-group-block"
      [ngClass]="{ 'with-group': withGroup() }"
    ></div>
    @for (day of sections; track day.day) {
      <div
        class="section"
        [ngStyle]="{ height: day.height + 'px' }"
        [ngClass]="{ current: day.isCurrentDay, grayed: day.grayed }"
      >
        <div class="content" #days>
          <div class="day">
            {{ day.day }}
          </div>
          <div class="right">
            <div class="day-week">
              {{ day.weekDay }}
            </div>
            <div class="month">
              {{ day.month }}
            </div>
          </div>
        </div>
        @if (day.isCurrentDay) {
          <div class="corner top-left"></div>
        }
      </div>
    }
  </div>
}
